/**
 * The inverse of Utils/Mission calculateTimeOfDay: a time of day as the
 * local "HH:mm" a mission should start at, from the city's check-in times.
 * Used by the bulk edit's Morning / Lunch / Afternoon quick pick.
 */

export const TIME_OF_DAY = {
  MORNING: 'MORNING',
  LUNCH: 'LUNCH',
  AFTERNOON: 'AFTERNOON',
}

const DEFAULT_MORNING = '09:00'
const DEFAULT_LUNCH = '12:00'
const DEFAULT_AFTERNOON = '15:00'

const hhmm = value => (value ? String(value).slice(0, 5) : null)

/**
 * @param {string} timeOfDay TIME_OF_DAY value
 * @param {{morningCheckInTime?: string, lunchCheckInTime?: string, afternoonCheckInTime?: string}} city
 * @returns {string} "HH:mm"
 */
export const timeOfDayToTime = (timeOfDay, city = {}) => {
  switch (timeOfDay) {
    case TIME_OF_DAY.LUNCH:
      return hhmm(city.lunchCheckInTime) || DEFAULT_LUNCH
    case TIME_OF_DAY.AFTERNOON:
      return hhmm(city.afternoonCheckInTime) || DEFAULT_AFTERNOON
    default:
      return hhmm(city.morningCheckInTime) || DEFAULT_MORNING
  }
}

/**
 * Puts a time of day onto a date: "2026-09-22" + AFTERNOON -> "2026-09-22 15:00".
 * The result is a city-local date time string as the API's bulk edit expects.
 * @param {string} dateYmd "YYYY-MM-DD"
 * @param {string} timeOfDay
 * @param {object} city
 * @returns {string}
 */
export const localDateTimeFor = (dateYmd, timeOfDay, city) =>
  `${dateYmd} ${timeOfDayToTime(timeOfDay, city)}`
